var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-radio-group',{staticClass:"font-weight-bold",attrs:{"value":_vm.value},on:{"input":(value) => {
    _vm.$emit('input', value)
  }}},[_c('a-radio',{attrs:{"value":"SOFT"}},[_vm._v(" Soft Bundling ")]),_c('a-radio',{attrs:{"value":"HARD"}},[_vm._v(" Hard Bundling ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }